import { render, staticRenderFns } from "./ContestTile.vue?vue&type=template&id=53be087a&scoped=true&"
import script from "./ContestTile.vue?vue&type=script&lang=js&"
export * from "./ContestTile.vue?vue&type=script&lang=js&"
import style0 from "./ContestTile.vue?vue&type=style&index=0&id=53be087a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be087a",
  null
  
)

export default component.exports